import { useMemo } from 'react';
import { Flex } from 'foundations-components/components/Flex';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { AddIcon } from 'foundations-assets/icons/components/AddIcon';
import { SettingsIcon } from 'foundations-assets/icons/components/SettingsIcon';
import ManageVariantsLink from 'personalization-lib/components/shared/links/ManageVariantsLink';
import CreateVariantButton from 'personalization-lib/components/variantCreation/CreateVariantButton';
import usePersonalizationStrategy from 'personalization-lib/hooks/variants/usePersonalizationStrategy';
import { getInitialDataForStrategy } from 'personalization-lib/utils/variantCreation';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const VariantSelectFooter = ({
  strategyId,
  defaultAsset
}) => {
  var _defaultAsset$assetDa2;
  const {
    strategy
  } = usePersonalizationStrategy(strategyId);
  const initialData = useMemo(() => {
    var _defaultAsset$assetDa;
    return getInitialDataForStrategy(strategy, defaultAsset === null || defaultAsset === void 0 || (_defaultAsset$assetDa = defaultAsset.assetData) === null || _defaultAsset$assetDa === void 0 ? void 0 : _defaultAsset$assetDa.name);
  }, [strategy, defaultAsset === null || defaultAsset === void 0 || (_defaultAsset$assetDa2 = defaultAsset.assetData) === null || _defaultAsset$assetDa2 === void 0 ? void 0 : _defaultAsset$assetDa2.name]);
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    gap: "400",
    children: [/*#__PURE__*/_jsx(CreateVariantButton, {
      buttonProps: {
        use: 'link'
      },
      variantInitialData: initialData,
      tooltipProps: {
        placement: 'left'
      },
      trackingProps: {
        actionSource: 'variant-select-footer'
      },
      label: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(IconHolder, {
          icon: AddIcon,
          size: "300",
          compact: true
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "personalizationLib.variantSelect.footer.addVariant"
        })]
      })
    }), /*#__PURE__*/_jsx(View, {
      children: /*#__PURE__*/_jsx(ManageVariantsLink, {
        label: /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(IconHolder, {
            icon: SettingsIcon,
            size: "300",
            marginInlineEnd: "200",
            compact: true
          }), /*#__PURE__*/_jsx(FormattedMessage, {
            message: "personalizationLib.shared.manageVariants"
          })]
        }),
        strategyId: strategyId
      })
    })]
  });
};
export default VariantSelectFooter;